import { createStore } from 'vuex'

export default createStore({
  state: {
    inscricao: {
      nome: "",
      email: "",
      numero: "",
      telefone: "",
    },
  },
  mutations: {
  },
  actions: {

  },
  modules: {
  }
})
